<template>
  <div>
    <table
      v-if="!loading && Object.keys(data).length"
      class="table"
    >
      <thead>
        <tr>
          <th>Запрос</th>
          <th>Позиция</th>
          <th>Ресурс</th>
          <th>Ссылка</th>
          <th>Тональность</th>
        </tr>
      </thead>

      <tbody>
        <tr
          v-for="(row, index) in dataTable"
          :key="index"
        >
          <td>{{ row.q }}</td>
          <td>{{ row.position }}</td>
          <td>{{ row.site }}</td>
          <td><a :href="row.url">{{ row.url }}</a></td>
          <td>
            <img
              :src="checkTone(row.tonality) ? require(`../../img/emoticons/${row.tonality}.svg`) : null"
              :alt="row.tonality"
            >
          </td>
        </tr>
      </tbody>
    </table>
    <no-data v-if="!loading && !data.length" />
  </div>
</template>

<script>
import NoData from '../../../../../../../resources/js/components/NoData.vue'
import analytics from './mixins/analytics'

export default {
  name: 'AnalyticsYandex',
  components: { NoData },
  mixins: [analytics],
  props: {
    data: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    dataTable () { // трансформация входных данных
      const table = []
      for (const [query, queryData] of Object.entries(this.data)) {
        for (const qData of queryData) {
          table.push({ q: query, ...qData })
        }
      }
      return table
    }
  }
}
</script>
